import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Box, Container, Paper, Typography } from "@mui/material";
import MenuService from "../../components/Menu/menuService";

const ContactUs = () => {
  const { selectPage } = MenuService();

  useEffect(() => {
    selectPage("contact-us");
  }, []);

  return (
    <Container
      maxWidth="lg"
      sx={{
        paddingTop: "50px",
        paddingBottom: "50px",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          rowGap: 1,
          alignItems: "flex-start",
        }}
      >
        <Box sx={{ marginBottom: "30px" }}>
          <Typography variant="h1">Get in touch with Collecticos</Typography>
        </Box>
        <Box>
          <Paper
            elevation={3}
            sx={{
              maxWidth: 600,
              width: "100%",
              padding: "1.5rem 0.5rem",
              borderRadius: 2,
            }}
          >
            <Box sx={{ marginBottom: 2 }}>
              <Typography variant="body1" gutterBottom>
                Have a question, feedback, or need assistance? We're here to
                help!
              </Typography>
            </Box>
            <Box sx={{ marginBottom: 2 }}>
              <Typography variant="body1" component="div">
                Support Email: For any inquiries, feel free to reach out to us
                at{" "}
                <Link to="mailto:support@collecticos.com" color="primary">
                  support@collecticos.com
                </Link>
              </Typography>
              <Typography variant="body1" component="div">
                Our team will get back to you as soon as possible.
              </Typography>
            </Box>
            <Box sx={{ marginBottom: 2 }}>
              <Typography variant="body1" component="div">
                Address: Prefer traditional mail? You can find us at:
              </Typography>
              <Typography variant="body1" component="div">
                John M. Keynesplein 12-46
              </Typography>
              <Typography variant="body1" component="div">
                1066 EP Amsterdam
              </Typography>
              <Typography variant="body1" component="div">
                Netherlands
              </Typography>
            </Box>
            <Typography variant="body1" gutterBottom>
              Whether you're a passionate collector or just exploring, we'd love
              to hear from you. Let's connect and make your collecting journey
              even better!
            </Typography>
          </Paper>
        </Box>
      </Box>
    </Container>
  );
};

export default ContactUs;
